// PLP Member Links Section JavaScript
document.addEventListener('DOMContentLoaded', () => {
  // Smooth scroll for member links with hash navigation
  document.querySelectorAll('.member-links__item').forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();

      const hash = e.target.hash;
      
      // Check if the hash exists and the target element is found
      if (hash && document.querySelector(hash)) {
        const targetElement = document.querySelector(hash);
        const scrollPosition = targetElement.offsetTop;
        
        // Update browser history
        window.history.pushState(null, null, hash);
        
        // Smooth scroll to target with offset
        window.scrollTo({
          top: scrollPosition - 100,
          behavior: 'smooth'
        });
      }
    });
  });
});